import React, { memo, useCallback, useState, useEffect, useRef } from 'react'
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Typography,
  Alert
} from '@mui/material'
import {
  KeyboardArrowUp,
  KeyboardArrowDown,
  AddCircleOutline,
  DeleteForever
} from '@mui/icons-material'

const Pattern = props => {
  const opts1 = [
    'GroupTransactionRef',
    'Reference1',
    'TransactionRef',
    'AddlText1',
    'AddlRef1',
    'Parameter1',
    'PartyName'
  ]
  const opts2 = ['AccountingSchemeCode', 'ItemID', 'VendorID', 'BankAcClass']

  const AccountingSchemeCode = {
    CreditCard: ['D(IGST)C(CC)', 'D(EI)C(CC)', 'D(VE)C(CC)', 'D(CA)C(CC)'],
    PettyCash: ['D(EI)C(PC)', 'D(CA)C(PC)', 'D(VE)C(PC)'],
    DigitalWalletAccounting: [
      'D(EI)C(DW)',
      'D(VE)C(DW)',
      'D(DW)C(BK-OUT)',
      'D(CA)C(DW)'
    ],
    EmployeeReimbursement: ['D(EI)C(ER)', 'D(CA)C(ER)']
  }

  const [PATTERN_JSON, setPATTERN_JSON] = useState(props.PATTERN_JSON)
  const [tempPatName, setTempPatName] = useState('')
  const [CUR_PAT_NAME, setCUR_PAT_NAME] = useState('')
  const [switch_Pattern, setSwitch_Pattern] = useState(false)
  const [CURRENT_PATTERN, setCURRENT_PATTERN] = useState(null)
  const [saveBtn, setSaveBtn] = useState(false)
  const [AccSchemeCds, set_AccSchemeCds] = useState([])
  const [ItemIdName, set_ItemIdName] = useState('')
  const [VendorIdName, set_VendorIdName] = useState('')
  const [errMsg, setErrMsg] = useState('')

  useEffect(() => {
      console.log("here2");

    if (props?.ROW?.['PatternID']) {
      console.log("here1");

      onSwitchPat(props?.ROW?.['PatternID'])
    } else {
      console.log("here");
      
      onSwitchPat('new')
      setSwitch_Pattern(true)
    }
    set_AccSchemeCds(AccountingSchemeCode[props.LedgerType])
  }, [])

  const onSwitchPat = val => {
    if (val === 'new') {
      console.log("val");
      setCUR_PAT_NAME(val)
      setSaveBtn(false)
      setCURRENT_PATTERN(null)
    } else {
      setCUR_PAT_NAME(val)
      setSaveBtn(false)

      let currr = PATTERN_JSON?.[val]

      currr &&
        currr.TextPatterns.forEach((each, indx) => {
          try {
            const regex1 = new RegExp(each.Prefix + each.Extract + each.Suffix)
            const ans = props?.ROW?.['ItemDescription'].match(regex1)

            if (ans && ans[1]) {
              currr.TextPatterns[indx]['ExtractedValue'] = ans[1]
            } else {
              currr.TextPatterns[indx]['ExtractedValue'] = 'No match'
            }
          } catch (error) {
            currr.TextPatterns[indx]['ExtractedValue'] = 'Invalid re expression'
          }
        })

      setCURRENT_PATTERN(currr)
    }
  }

  const setCurPat = (current_Pat, save_Btn) => {
    setSaveBtn(true)
    setCURRENT_PATTERN(current_Pat)
  }

  const editPAT = (e, TorV) => {
    let key = e.target.name
    let val = e.target.value
    let current_Pat = JSON.parse(JSON.stringify(CURRENT_PATTERN))

    if (key === 'Extract') handleMatchClick(e)
    else if (key === 'Type') {
      current_Pat[key] = val
      setCurPat(current_Pat)
    } else {
      let indx = e.target.id

      if (key === 'Key') {
        let obj = { [val]: '' }
        current_Pat[TorV][indx] = obj
      } else if (key === 'ItemID') {
        const selectedName = e.target.getAttribute('sendName')
        set_ItemIdName(selectedName)
        current_Pat[TorV][indx][key] = val
      } else if (key === 'VendorID') {
        const selectedName = e.target.getAttribute('sendName')
        set_VendorIdName(selectedName)
        current_Pat[TorV][indx][key] = val
      } else {
        if (val !== 'GroupTransactionRef') {
          current_Pat[TorV][indx][key] = val
        }
      }
      setCurPat(current_Pat)
    }
  }

  const handleMatchClick = e => {
    let indx = e.target.id
    let key = e.target.name
    let val = e.target.value

    const prefix = props.LedgerType === 'CreditCard' ? '(' : '(.*?'
    const suffix = props.LedgerType === 'CreditCard' ? ')' : '.*?)'
    val = prefix + val + suffix

    const lengthCheck = props.LedgerType === 'CreditCard' ? 2 : 8

    if (
      val.startsWith(prefix) &&
      val.endsWith(suffix) &&
      val.length >= lengthCheck
    ) {
      let current_Pat = JSON.parse(JSON.stringify(CURRENT_PATTERN))
      current_Pat.TextPatterns[indx][key] = val

      try {
        let each = current_Pat.TextPatterns[indx]
        const regex = new RegExp(each.Prefix + each.Extract + each.Suffix)
        const match = props?.ROW?.['ItemDescription'].match(regex)

        if (match && match[1]) {
          current_Pat.TextPatterns[indx]['ExtractedValue'] = match[1]
          setCurPat(current_Pat)
        } else {
          current_Pat.TextPatterns[indx]['ExtractedValue'] = 'No match'
          setCurPat(current_Pat)
        }
      } catch (error) {
        current_Pat.TextPatterns[indx]['ExtractedValue'] =
          'Invalid re expression'
        setCurPat(current_Pat)
      }
    }
  }

  const addRow = (TorV, indx) => {
    let newObj

    if (TorV === 'TextPatterns') {
      newObj = {
        FieldName: '',
        Prefix: '',
        Extract: props.LedgerType === 'CreditCard' ? '()' : '(.*?.*?)',
        Suffix: ''
      }
    } else {
      newObj = { '': '' }
    }

    let current_Pat = JSON.parse(JSON.stringify(CURRENT_PATTERN))
    current_Pat[TorV].splice(indx + 1, 0, newObj)
    setCurPat(current_Pat)
  }

  const delRow = (TorV, indx) => {
    let current_Pat = JSON.parse(JSON.stringify(CURRENT_PATTERN))
    current_Pat[TorV].splice(indx, 1)
    setCurPat(current_Pat)
  }

  const CreateNewPat = () => {
    const newPat = {
      Sample: '',
      Type: '',
      TextPatterns: [
        {
          FieldName: '',
          Prefix: '',
          Extract: props.LedgerType === 'CreditCard' ? '()' : '(.*?.*?)',
          Suffix: ''
        }
      ],
      ValueAssignments: [{ '': '' }]
    }

    if (Object.keys(PATTERN_JSON).includes(tempPatName)) {
      setErrMsg('Pattern Name Already Exists')
      setTimeout(() => setErrMsg(''), 3000)
    } else {
      let PATTERN_JSON_ = JSON.parse(JSON.stringify(PATTERN_JSON))
      PATTERN_JSON_[tempPatName] = newPat

      setCUR_PAT_NAME(tempPatName)
      setPATTERN_JSON(PATTERN_JSON_)
      setCurPat(PATTERN_JSON_[tempPatName])
      setTempPatName('')
    }
  }

  const saveModifiedPat = () => {
    setErrMsg('')
    let PATTERN_JSON_ = JSON.parse(JSON.stringify(PATTERN_JSON))
    PATTERN_JSON_[CUR_PAT_NAME] = JSON.parse(JSON.stringify(CURRENT_PATTERN))

    let tosend = {
      PatternID: CUR_PAT_NAME,
      ItemID: '',
      ItemName: ItemIdName,
      VendorID: '',
      VendorName: VendorIdName
    }

    PATTERN_JSON_[CUR_PAT_NAME].ValueAssignments.forEach(one => {
      let keys = Object.keys(one)
      tosend[keys[0]] = one[keys[0]]
    })

    if (!PATTERN_JSON_[CUR_PAT_NAME].Type) {
      setErrMsg(`Please provide "match" or "search"`)
    } else if (tosend.AccountingSchemeCode) {
      if (
        [
          'D(IGST)C(CC)',
          'D(CA)C(CC)',
          'D(CA)C(PC)',
          'D(CA)C(DW)',
          'D(CA)C(ER)'
        ].includes(tosend.AccountingSchemeCode)
      ) {
        setSaveBtn(false)
        props.on_Save(PATTERN_JSON_, tosend)
      } else if (
        ['D(EI)C(CC)', 'D(EI)C(PC)', 'D(EI)C(DW)', 'D(EI)C(ER)'].includes(
          tosend.AccountingSchemeCode
        )
      ) {
        if (tosend['ItemID']) {
          setSaveBtn(false)
          props.on_Save(PATTERN_JSON_, tosend)
        } else {
          setErrMsg('Please provide ItemID')
        }
      } else if (
        ['D(VE)C(CC)', 'D(VE)C(DW)', 'D(VE)C(PC)'].includes(
          tosend.AccountingSchemeCode
        )
      ) {
        if (tosend['VendorID']) {
          setSaveBtn(false)
          props.on_Save(PATTERN_JSON_, tosend)
        } else {
          setErrMsg('Please provide VendorID')
        }
      } else if (['D(DW)C(BK-OUT)'].includes(tosend.AccountingSchemeCode)) {
        if (tosend['BankAcClass']) {
          setSaveBtn(false)
          props.on_Save(PATTERN_JSON_, tosend)
        } else {
          setErrMsg('Please provide BankAcClass')
        }
      }
    } else {
      setErrMsg('Please provide AccountingSchemeCode')
    }
  }

  const moveKeyUp = () => {
    let key = CUR_PAT_NAME
    let obj = JSON.parse(JSON.stringify(PATTERN_JSON))
    const keys = Object.keys(obj)
    const index = keys.indexOf(key)

    if (index > 0) {
      const temp = keys[index - 1]
      keys[index - 1] = key
      keys[index] = temp
    }

    const newObj = {}
    keys.forEach(k => {
      newObj[k] = obj[k]
    })
    setPATTERN_JSON(newObj)
  }

  const moveKeyDown = () => {
    let key = CUR_PAT_NAME
    let obj = JSON.parse(JSON.stringify(PATTERN_JSON))
    const keys = Object.keys(obj)
    const index = keys.indexOf(key)

    if (index < keys.length - 1) {
      const temp = keys[index + 1]
      keys[index + 1] = key
      keys[index] = temp
    }

    const newObj = {}
    keys.forEach(k => {
      newObj[k] = obj[k]
    })
    setPATTERN_JSON(newObj)
  }

  return (
    <Dialog
      open={true}
      onClose={() => props.setPopupVisible(false)}
      maxWidth='lg'
      fullWidth
    >
      <DialogContent>
        {PATTERN_JSON && (
          <Grid container spacing={2} sx={{ mb: 2, mt: 1 }}>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Pattern ID</InputLabel>
                <Select
                  value={CUR_PAT_NAME}
                  disabled={!switch_Pattern}
                  onChange={e => onSwitchPat(e.target.value)}
                  label='Pattern ID'
                >
                  <MenuItem value=''>
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value='new'>&lt;&lt; create new &gt;&gt;</MenuItem>
                  {Object.keys(PATTERN_JSON).map(each => (
                    <MenuItem key={each} value={each}>
                      {each}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={2}>
              <Button variant='contained' onClick={() => onSwitchPat('new')}>
                Create New
              </Button>
            </Grid>

            {CUR_PAT_NAME && CUR_PAT_NAME !== 'new' && (
              <Grid
                item
                xs={12}
                md={3}
                sx={{ display: 'flex', alignItems: 'center' }}
              >
                <IconButton onClick={moveKeyUp}>
                  <KeyboardArrowUp />
                </IconButton>
                <Typography sx={{ mx: 1 }}>
                  {Object.keys(PATTERN_JSON).indexOf(CUR_PAT_NAME) + 1}/
                  {Object.keys(PATTERN_JSON).length}
                </Typography>
                <IconButton onClick={moveKeyDown}>
                  <KeyboardArrowDown />
                </IconButton>
              </Grid>
            )}
          </Grid>
        )}

        {CUR_PAT_NAME === 'new' && (
          <Box sx={{ mb: 2 }}>
            <Typography variant='body1' gutterBottom>
              Pattern ID:
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <TextField
                placeholder='Enter Pattern Name'
                value={tempPatName}
                onChange={e => setTempPatName(e.target.value)}
                fullWidth
                size='small'
              />
              <Button
                variant='contained'
                onClick={CreateNewPat}
                disabled={!tempPatName}
                color='warning'
              >
                Create
              </Button>
            </Box>
            {errMsg && (
              <Alert severity='error' sx={{ mt: 1 }}>
                {errMsg}
              </Alert>
            )}
          </Box>
        )}

        {CURRENT_PATTERN && (
          <>
            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid item xs={12} md={8}>
                <TextField
                  label='Item Description'
                  value={props?.ROW?.['ItemDescription'] || ''}
                  disabled
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControl fullWidth>
                  <InputLabel>Type</InputLabel>
                  <Select
                    name='Type'
                    value={CURRENT_PATTERN.Type}
                    onChange={e => editPAT(e, 'TextPatterns')}
                    label='Type'
                  >
                    <MenuItem value='' disabled>
                      <em>None</em>
                    </MenuItem>
                    <MenuItem value='match'>match</MenuItem>
                    <MenuItem value='search'>search</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <Table sx={{ minWidth: 650 }} size='small'>
              <TableHead>
                <TableRow>
                  <TableCell width={50}></TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Field Name</TableCell>
                  <TableCell>Prefix Exp</TableCell>
                  <TableCell>Extract Exp</TableCell>
                  <TableCell>Suffix Exp</TableCell>
                  <TableCell>Extracted Value</TableCell>
                  <TableCell width={50}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {CURRENT_PATTERN.TextPatterns.map((item, rowIndex) => (
                  <TableRow key={`text-${rowIndex}`}>
                    <TableCell>
                      <IconButton
                        onClick={() => addRow('TextPatterns', rowIndex)}
                        size='small'
                      >
                        <AddCircleOutline />
                      </IconButton>
                    </TableCell>
                    <TableCell>TextPatterns</TableCell>
                    <TableCell>
                      <FormControl fullWidth size='small'>
                        <Select
                          name='FieldName'
                          value={item.FieldName}
                          onChange={e => editPAT(e, 'TextPatterns')}
                          id={rowIndex.toString()}
                        >
                          <MenuItem value=''>
                            <em>None</em>
                          </MenuItem>
                          {opts1.map(each => {
                            if (props.LedgerType === 'CreditCard') {
                              return (
                                <MenuItem key={each} value={each}>
                                  {each}
                                </MenuItem>
                              )
                            } else if (each === 'PartyName') {
                              return (
                                <MenuItem key={each} value={each}>
                                  {each}
                                </MenuItem>
                              )
                            }
                            return null
                          })}
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell>
                      <TextField
                        name='Prefix'
                        value={item.Prefix}
                        onChange={e => editPAT(e, 'TextPatterns')}
                        disabled={props.LedgerType !== 'CreditCard'}
                        size='small'
                        fullWidth
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        name='Extract'
                        value={
                          props.LedgerType === 'CreditCard'
                            ? item.Extract.replace('(', '').replace(')', '')
                            : item.Extract.replace('(.*?', '').replace(
                                '.*?)',
                                ''
                              )
                        }
                        onChange={e => editPAT(e, 'TextPatterns')}
                        size='small'
                        fullWidth
                        id={rowIndex.toString()}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        name='Suffix'
                        value={item.Suffix}
                        onChange={e => editPAT(e, 'TextPatterns')}
                        disabled={props.LedgerType !== 'CreditCard'}
                        size='small'
                        fullWidth
                      />
                    </TableCell>
                    <TableCell>{item.ExtractedValue}</TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() =>
                          rowIndex !== 0 && delRow('TextPatterns', rowIndex)
                        }
                        size='small'
                        disabled={rowIndex === 0}
                      >
                        <DeleteForever />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                {CURRENT_PATTERN.ValueAssignments.map((item, rowIndex) => (
                  <TableRow key={`value-${rowIndex}`}>
                    <TableCell>
                      <IconButton
                        onClick={() => addRow('ValueAssignments', rowIndex)}
                        size='small'
                      >
                        <AddCircleOutline />
                      </IconButton>
                    </TableCell>
                    <TableCell>ValueAssignments</TableCell>
                    <TableCell>
                      <FormControl fullWidth size='small'>
                        <Select
                          name='Key'
                          value={Object.keys(item)[0]}
                          onChange={e => editPAT(e, 'ValueAssignments')}
                          id={rowIndex.toString()}
                        >
                          <MenuItem value=''>
                            <em>None</em>
                          </MenuItem>
                          {opts2.map(each => (
                            <MenuItem key={each} value={each}>
                              {each}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell>
                      <FormControl fullWidth size='small'>
                        <Select
                          name={Object.keys(item)[0]}
                          value={item[Object.keys(item)[0]]}
                          onChange={e => editPAT(e, 'ValueAssignments')}
                          id={rowIndex.toString()}
                        >
                          <MenuItem value=''>
                            <em>None</em>
                          </MenuItem>
                          {Object.keys(item)[0] === 'AccountingSchemeCode' &&
                            AccSchemeCds.map(each => (
                              <MenuItem key={each} value={each}>
                                {each}
                              </MenuItem>
                            ))}
                          {Object.keys(item)[0] === 'ItemID' &&
                            props.IM.map(each => (
                              <MenuItem
                                key={each['ItemID']}
                                value={each['ItemID']}
                                sendName={each['ItemName']}
                              >
                                {`${each['ItemName']}(${each['ItemID']})`}
                              </MenuItem>
                            ))}
                          {Object.keys(item)[0] === 'VendorID' &&
                            props.VM.map(each => (
                              <MenuItem
                                key={each['VendorID']}
                                value={each['VendorID']}
                                sendName={each['VendorName']}
                              >
                                {`${each['VendorName']}(${each['VendorID']})`}
                              </MenuItem>
                            ))}
                          {Object.keys(item)[0] === 'BankAcClass' &&
                            props.BankAcClass.map(each => (
                              <MenuItem
                                key={each['BankAcClass']}
                                value={each['BankAcClass']}
                              >
                                {each['BankAcClass']}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() =>
                          rowIndex !== 0 && delRow('ValueAssignments', rowIndex)
                        }
                        size='small'
                        disabled={rowIndex === 0}
                      >
                        <DeleteForever />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>

            <Box sx={{ textAlign: 'right', mt: 2 }}>
              <Button
                variant={saveBtn ? 'contained' : 'outlined'}
                disabled={!saveBtn}
                onClick={saveModifiedPat}
              >
                Save
              </Button>
              {errMsg && (
                <Alert severity='error' sx={{ mt: 1 }}>
                  {errMsg}
                </Alert>
              )}
            </Box>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.setPopupVisible(false)}>Close</Button>
      </DialogActions>
    </Dialog>
  )
}

export default Pattern
